export default {
  title: "Тарифтер",
  tariff: "Тариф",
  yourTariff: "Сиздин тариф",
  lessTariffModal: {
    title: "Сиздин тариф боюнча сыйлык карталарын чыгаруу жеткиликтүү эмес",
    subtitle:
      "Сыйлык карталарын чыгаруу үчүн «Промо» же «Про+» тарифине өтүңүз",
  },
  lite_p: {
    title: "Лайт",
    list: [
      '<span itemprop="name">1 юр. жакты каттоо',
      '<span itemprop="name">5 сатуу пунктун түзүү',
      '<span itemprop="name">Жөнөкөйлөштүрүлгөн статистика',
      '<span itemprop="name">RC KASSAга жеткиликтүүлүк',
      '<span itemprop="name">Электрондук документооборот',
      '<span itemprop="name">Айына 2 жолу эсептешүү',
      '<span itemprop="name">Суроолор жана жооптор бөлүмү',
    ],
  },

  promo_p: {
    title: "Промо",
  },

  pluspro_p: {
    title: "Про+",
  },

  faq: [
    {
      title: "Кардарды санариптештирүү кантип жүргүзүлөт?",
      text:
        "<p>Кардарды санариптештирүү үчүн ага промокод беришиңиз керек. Бул код рефералдык шилтеме, QR-код же түз код болушу мүмкүн. Кодду колдонуп кардар rcpay.ru сервисинде катталуусу керек.</p>" +
        "<br>" +
        "<p>Эскертүү: QR-кодду окуу үчүн кардардын камерасы же QR-код окуучу атайын тиркеме болушу керек.</p>",
    },
    {
      title: "«Активдүү» кардар деген эмне?",
      text:
        "<p>Бул сиз санариптештирген кардар, RC Group экосистемасынын онлайн же офлайн заведениесинде сатып алуу жасаган. Онлайн сатып алуулар RC Marketтен соода, сертификаттарды алуу, Яндекс сервисин активдештирүү, колдонуучу тарифин сатып алуу. Офлайн операциялар – шаардагы заведениелерде RC.Kassa колдонуу менен сатып алуу.</p>" +
        "<br>" +
        "<p>«Корпоративдик» тарифти сатып алганда, ар бир өнөктөш «50% жеңилдик» акциясына катышат. Бул акциянын негизги шарттары – 500 жана андан көп «активдүү» кардарды санариптештирүү.</p>",
    },
    {
      title: "Тарифти жаңыртпасам эмне болот?",
      text: "<p>Бул учурда кабинеттин функциясы «Базалык» тариф деңгээлине чейин кыскарат. «Кардарлар тизмеси» бөлүмү жеткиликтүү болот, бирок Wallet карталарын чыгаруу, Push билдирүүлөрдү жөнөтүү жана «Картасыз чай акысы» сервисине жеткиликтүүлүк жоголот.</p>",
    },
    {
      title: "Кантип көбүрөөк кардарды санариптештирсем болот?",
      text: "<p>«Бөлүшүү» функциясын колдонуп, санариптештирүү үчүн рефералдык шилтемени соцтармактарда жайгаштырыңыз. Ошондой эле тейбл-тент, стикерлер, флайерлер, воблерлерди заведениеде жайгаштырыңыз.</p>",
    },
    {
      title: "Менин суроом жок, жооп алсам болобу?",
      text:
        "<p>Техникалык колдоого суроо бериңиз. Бул үчүн төмөнкү оң бурчтагы RC Group иконкасын басып, «Telegram» тандаңыз жана көйгөйүңүздү билдирип, зарыл болсо скриндерди кошуңуз. Биздин адис кыска мөөнөттө сиз менен байланышат.</p>" +
        "<br>" +
        "<p>Ошондой эле, emailге жөнөтө аласыз: <a href='mailto:hello@rc.company'>hello@rc.company</a></p>" +
        "<br>" +
        "Же телефон аркылуу чалыңыз: <b>8 (800) 500-57-62.</b></p>",
    },
  ],
  digitizedClientsCounter: "Санариптештирилген кардарлардын эсептегичи",
  activeClientsDigitized: "Активдүү кардарлар санариптештирилди",
  reg500AndMoreClients:
    "50% жеңилдик алуу үчүн сыйлуулук программасына 500 жана андан көп <b>активдүү кардарды</b> каттаңыз",
  choosePointToGenerateQr:
    "RC PAYде жаңы кардарды каттоо үчүн шилтемени жана QR-кодду түзүү үчүн сатуу пунктун тандаңыз.",
  afterBuyTariffYouCanGenerate:
    "Тарифти сатып алгандан кийин RC PAYде жаңы кардарды каттоо үчүн шилтемени жана QR-кодду түзүү мүмкүн болот.",
  useLinkAndQrForRegNewClients:
    "RC PAYде жаңы кардарды каттоо үчүн шилтемени жана QR-кодду колдонуңуз.",
  shareLink: "Шилтемени бөлүшүү",
  anyOtherQuestions: "Суроолор калдыбы?",
  tariffSuccessPayed: "«{tariff}» тарифи ийгиликтүү төлөндү",
  tariffPayFromMainEntity:
    "Тарифтин төлөмү негизги юр. жактын фактикалык балансынан жүргүзүлөт.<br />",
  period: "Мөөнөт",
  cost: "Баасы",
  discount: "{discount}% жеңилдик",
  totalToPay: "Жалпы төлөм",
  lite: "Лайт",
  promo: "Промо",
  plusPro: "Про+",
  basic: "Базалык",
  corporate: "Корпоративдик",
  popular: "Популярдуу",
  advanced: "Кеңейтилген",
  includesToTariff: "Тарифке кирет",
  allInLitePlus: "Лайт тарифиндеги бардык, плюс",
  allInPromoPlus: "Промо тарифиндеги бардык",
  allInBasicPlus: "Базалык тарифиндеги бардык, плюс",
  forFree: "Бекер",
  buyTariff: "Тарифти сатып алуу",
  tradingPoints: "сатуу пункттары",
  products: "товарлар",
  unlimitProducts: "Чектелбеген товарлар",
  uCanAddProductsToEMenu:
    "{productsCount} товарларды онлайн-каталогго кошуп, RC PAYден онлайн заказ алуу мүмкүн",
  canAddUnlimitProductsToEMenu:
    "Онлайн-каталогго чектелбеген товарларды кошуп, RC PAYден онлайн заказ алуу мүмкүн",
  twoTgMailingPerWeek: "Аптада 2 жолу Telegramда жиберүү",
  oneTgMailingPerDay: "Күнүнө 1 жолу Telegramда жиберүү",
  canCreateAndSend2NotifyPerWeek:
    "Ар сатуу пунктунун кардарына аптасына 2 билдирүү Telegram-бот аркылуу жөнөтүүгө болот",
  canCreateAndSend1NotifyPerDay:
    "Ар сатуу пунктунун кардарына күнүнө 1 билдирүү Telegram-бот аркылуу жөнөтүүгө болот",
  basicAnalytics: "Негизги аналитика",
  analyticsHint: "Сатуу пункттары жана юр. жактар боюнча аналитика",
  accrualDeducationPoints: "RC KASSAда балл эсептөө жана списаниялоо",
  enablingPaymentMethods: "Төлөм ыкмаларын туташтыруу",
  postingYourShopsInRC: "Заведениелерди RC PAYде жайгаштыруу",
  postingYourShopsHint:
    "RC PAYде жайгаштыруу эрежелерине ылайык болгондо гана<br><br><a target='_blank' href='/docs/Правила размещения.pdf'>RC PAYде заведениелерди жайгаштыруу эрежелерин караңыз</a>",
  gettingOnlineOrders: "Сиздин товарлар/кызматтар боюнча онлайн-заказ алуу",
  orderPromotionYourShops: "Сатуу пункттарын илгерилетүү буйрук",
  advancedAnalytics: "Кеңейтилген аналитика",
  advancedAnalyticsHint:
    "Сатуу пункттары, юр. жактар, кассирлер, кардарлар жана RFM-аналитика",
  evaluationCashierWork: "Кассирлердин ишин баалоо",
  digitizingClients: "Кардарды санариптештирүү",
  accessToClientsList: "Кардарлар тизмесине жеткиликтүүлүк",
  infoAboutAllClients:
    "Бардык заведениени посещавший кардарлар тууралуу маалымат, байланыштары, чек жана статистика",
  pushNotifyToClientWalletCard: "Кардарларга Wallet картасына Push билдирүүлөр",
  scoringPointsByGroups: "Кардарлар боюнча балл эсептөө",
  uCanSetDifferentPercentAward:
    "Кардардын сатып алуусу суммасына жараша ар түрдүү сыйлык пайызы коюуга болот",
  distributionRCCard: "RC карталарын таратуу",
  designWalletCard: "Wallet картанын дизайны",
  issuingGiftCard: "Сыйлык карталарын чыгаруу",
  priorityMaintenance: "Приоритеттүү тейлөө",
  monetizationUpTo30Percent:
    "Кардарга берилген сыйлыктын 30% чейин монетизациялоо",
  monetizationHint:
    "Сыйлуулук программасынан киреше алуу мүмкүнчүлүгү бар болсо",
  adding1Entity: "1 юр. жакты кошуу",
  accessToOperationsHistory: "Операциялар тарыхына жеткиликтүүлүк",
  basicCabinetFunctional: "Кабинеттин негизги функциялары",
  discountOnTariffRenewal: "Тарифти узартууга 50% жеңилдик",
  discountOnTariffRenewalHint:
    "50% жеңилдик акыркы тариф сатып алынгандан кийин 500 жана андан көп активдүү кардарды санариптештирсе берилет<br><br><a href='#clients-counter'>Кардарлар эсептегичин караңыз</a>",
  autoConnectIfFreeTariff:
    "Эгер акы төлөнүүчү тариф сатып алынбаса, автоматтык туташтыруу",
  tariffBuyingWillAvailableFromDate:
    "Тарифти сатып алуу {date} датасынан жеткиликтүү болот",
  entityOnModeration: "Юр. жак модерацияда",
  tariffBuyingWillAvailableAfterModeration:
    "Тарифти сатып алуу юр. жак модерациядан өткөндөн кийин жеткиликтүү болот",
  notEnoughMoney: "Акча жетишсиз",
  tariffPayingFromFactBalance:
    "Тарифтин төлөмү негизги юр. жактын фактикалык балансынан жүргүзүлөт",
  forBuyingTariffNeedReplenish:
    "«{tariff}» тарифин сатып алуу үчүн {entity} балансын кеминде {sum} ₽ толуктоо керек",
  replenishBalance: "Баланс толуктоо",
  canCreate: "Түзүүгө болот",
  forTransitionToTariffConnectWithUs:
    "Акы төлөнүүчү тарифке өтүү үчүн техникалык колдоого кайрылыңыз",
  paidBefore: "Төлөнгөн мөөнөтү",
};
